var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.54532 17.3636C5.54532 18.3636 6.3635 19.1818 7.3635 19.1818H14.6362C15.6362 19.1818 16.4544 18.3636 16.4544 17.3636V8.27272C16.4544 7.27272 15.6362 6.45454 14.6362 6.45454H7.3635C6.3635 6.45454 5.54532 7.27272 5.54532 8.27272V17.3636ZM16.4544 3.72727H14.1817L13.5362 3.08181C13.3726 2.91818 13.1362 2.81818 12.8999 2.81818H9.09987C8.8635 2.81818 8.62714 2.91818 8.4635 3.08181L7.81805 3.72727H5.54532C5.04532 3.72727 4.63623 4.13636 4.63623 4.63636C4.63623 5.13636 5.04532 5.54545 5.54532 5.54545H16.4544C16.9544 5.54545 17.3635 5.13636 17.3635 4.63636C17.3635 4.13636 16.9544 3.72727 16.4544 3.72727Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete _icon.8cb94cd76c92e1d7a8cf4fbc574b1d0f.svg";
export { ForwardRef as ReactComponent };